export default __webpack_public_path__ + "static/media/Dynstr_HTB.d22ad8d9.md";